import { useNavigate, useParams } from "react-router-dom";
import HeroSection from "../../components/UserComponents/heroSection.jsx";
import ExperienceCard from "../../components/vendors/ExperienceCard";
import { usePublicExperiencesByLocation } from "../../custom-hooks/queries";
import { useMemo, useState } from "react";
import { debounce } from "../../utils/HelperMethod.js";

/* ---------------- Skeleton Card ---------------- */
const ExperienceCardSkeleton = () => (
  <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 animate-pulse">
    <div className="h-48 bg-gray-200"></div>
    <div className="p-4">
      <div className="h-3 w-20 bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-full bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-3/4 bg-gray-200 rounded mb-3"></div>
      <div className="flex justify-between items-center">
        <div className="h-5 w-16 bg-gray-200 rounded"></div>
        <div className="h-3 w-12 bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>
);

const ExploreLocationPage = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const handleSearchChange = (value) => {
    setSearch(value); // input ke liye instant
    debouncedSearch(value); // API ke liye delayed
  };
  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setDebouncedValue(value); // API trigger value
      }, 500),
    [],
  );

  /* ✅ locationId FROM ROUTE */
  const { locationId } = useParams();

  const { data: locationExperiencesData, isLoading } =
    usePublicExperiencesByLocation({
      page: 1,
      pageSize: 10,
      locationId,
      search: debouncedValue,
    });

  /* 🔹 API response mapping */
  const experiences = locationExperiencesData?.data?.data || [];

  const handleExperienceClick = (experienceId) => {
    navigate(`/user/location-detail/${experienceId}`);
  };

  return (
    <>
      {/* 🔥 HERO SECTION */}
      <HeroSection
        searchValue={search}
        onSearchChange={handleSearchChange}
        title="Discover Amazing Experiences Available in Your Selected Location"
        description="Browse experiences happening near you and plan something unforgettable with ease."
      />

      {/* 🔥 EXPERIENCE CARDS */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
        {isLoading ? (
          <div
            className="
          grid
          grid-cols-1
          sm:grid-cols-2
          md:grid-cols-3
          lg:grid-cols-4
          gap-4 sm:gap-5 lg:gap-6
        "
          >
            {[...Array(8)].map((_, i) => (
              <ExperienceCardSkeleton key={i} />
            ))}
          </div>
        ) : experiences.length > 0 ? (
          <div
            className="
          grid
          grid-cols-1
          sm:grid-cols-2
          md:grid-cols-3
          lg:grid-cols-4
          gap-4 sm:gap-5 lg:gap-6
        "
          >
            {experiences.map((item) => (
              <div
                key={item.experienceId}
                onClick={() => handleExperienceClick(item.experienceId)}
                className="
              cursor-pointer
              transition
              hover:scale-[1.01]
              active:scale-[0.99]
            "
              >
                <ExperienceCard
                  id={item.experienceId}
                  img={item.imageUrl}
                  title={item.title}
                  location={item.location}
                  price={item.priceFrom}
                  time={item.duration}
                  rating={item.ratingAvg}
                  tag="Experience"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="py-16 text-center">
            <p className="text-gray-500 text-sm sm:text-base">
              No experiences available
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default ExploreLocationPage;
